module.exports = {
  USD: 1,
  COP: 3472
}
